"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  "status": 200,
  "msg": "ok",
  "data": [{
    "id": 1,
    "pid": 0,
    "type": "link",
    "name": "应用页面",
    "title": "应用页面",
    "expand": true,
    "children": [{
      "id": 4,
      "pid": 1,
      "type": "marketing_link",
      "name": "营销链接",
      "title": "营销链接",
      "expand": true,
      "children": []
    }]
  }, {
    "id": 2,
    "pid": 0,
    "type": "custom",
    "name": "自定义",
    "title": "自定义",
    "expand": true,
    "children": [{
      "id": 15,
      "pid": 4,
      "type": "custom",
      "name": "自定义链接",
      "title": "自定义链接",
      "expand": true,
      "children": []
    }]
  }, {
    "id": 3,
    "pid": 0,
    "type": "micro",
    "name": "微页面",
    "title": "微页面",
    "expand": false
  }]
};